<template>
  <div class="container">
    <div class="classify-nav">
      <van-tabs
        type="line"
        v-model="active"
        title-active-color="#d62f2f"
        line-width="32px"
        line-height="5px"
        @change="typeClick"
      >
        <van-tab title="我创建的话题"></van-tab>
        <van-tab title="我参与讨论的话题"></van-tab>
      </van-tabs>
    </div>

    <div class="hasData" v-if="list != null && list.length > 0">
      <van-list
        v-model="loading"
        :finished="finished"
        :error.sync="error"
        error-text="请求失败，点击重新加载"
        @load="getListHandle"
      >
        <div v-for="(item, index) in list" :key="index">
          <div @click="toHotDetails(item.TopicId)">
            <div class="topicItem">
              <div class="ti_left">
                <div class="tilTitle overFlowOne">#{{ item.TopicName }}#</div>
                <div class="overFlowTwo">{{ item.TopicDesc }}</div>
                <div class="times" v-if="active == 1">
                  创建: {{ item.CreateTimeStr }}
                  <div style="margin-left: 10px">浏览: {{ item.Views }}次</div>
                  <div style="margin-left: 10px">
                    帖子: {{ item.PostCount }}条
                  </div>
                </div>
                <div class="times times_mine" v-else>
                  <div style="width: 195px; display: flex">
                    创建: {{ item.CreateTimeStr }}
                    <div style="margin-left: 10px">
                      浏览: {{ item.Views }}次
                    </div>
                  </div>
                  <div class="ellipsisView">
                    <div
                      class="iconfont icon-ellipsis"
                      @click.stop="handleClick(index)"
                    ></div>
                    <div class="elv_black" v-if="item.edit">
                      <div @click.stop="closeClick(item.TopicId)">关闭话题</div>
                      <div @click.stop="deleteClick(item.TopicId)">删除</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tiImg">
                <div class="redDot" v-if="active == 0 && item.NewCount > 0">
                  {{ item.NewCount }}
                </div>
                <van-image fit="cover" :src="item.BackImage" />
              </div>
            </div>
          </div></div
      ></van-list>
    </div>
    <div class="noDataBox" v-else>
      <span class="iconfont icon-kong"></span>
      <div style="font-size: 13px">您居然还没创建过话题？来创建一个试试！</div>
      <div class="createBtn" @click="createTopic">创建话题</div>
    </div>
  </div>
</template>
<script>
import { List, Tab, Tabs, Toast, Image } from "vant";
import { memberTopicList } from "@/api/homepage";
import { closeMemberTopic, deleteMemberTopic } from "@/api/topic";
export default {
  name: "myTopic",
  components: {
    "van-tabs": Tabs,
    "van-tab": Tab,
    "van-list": List,
    "van-image": Image,
  },
  data() {
    return {
      active: 0, //0我创建  1我参与的
      loading: false,
      finished: false,
      total: 0,
      pageIndex: 1,
      error: false,
      list: [],
    };
  },
  methods: {
    //操作点击
    handleClick(idx) {
      var that = this;
      this.list.forEach(function (item, index) {
        if (idx == index) {
          item.edit = !item.edit;
          that.$set(that.list, index, item);
        } else {
          item.edit = false;
        }
      });
    },

    //关闭话题
    closeClick(id) {
      var data = {
        TopicId: id,
      };
      closeMemberTopic(data).then((res) => {
        Toast("关闭话题成功");
        this.pageIndex = 1;
        location.reload();
      });
    },

    //删除话题
    deleteClick(id) {
      var data = {
        TopicId: id,
      };
      deleteMemberTopic(data).then((res) => {
        Toast("删除话题成功");
        this.pageIndex = 1;
        this.getListHandle();
      });
    },

    //跳转话题详情
    toHotDetails(id) {
      this.$router.push({ path: "/hotTopicDetails", query: { hid: id } });
    },

    //创建话题
    createTopic() {
      this.$router.push("/publishTopic");
    },

    //tab切换
    typeClick(name, title) {
      this.active = name;
      this.pageIndex = 1;
      this.getListHandle();
    },

    //获取会员话题列表
    getListHandle() {
      var that = this;
      var data = {
        MemberId: 0,
        Type: that.active,
        Page: {
          PageSize: 10,
          PageIndex: that.pageIndex,
        },
      };
      memberTopicList(data)
        .then((res) => {
          if (that.pageIndex == 1) {
            that.list = [...res.Data.List];
          } else {
            that.list = [...that.list, ...res.Data.List];
          }
          that.total = res.Data.Total;
          that.pageIndex += 1;
          that.loading = false;
          if (that.list.length >= that.total) {
            that.finished = true;
          }
        })
        .catch((err) => {
          that.loading = false;
          that.error = true;
          that.Common.showMsg(err);
        });
    },
  },
  mounted() {
    this.getListHandle();
  },
};
</script>
<style lang="less" scoped>
.container {
  .classify-nav {
    font-size: 14px;
    padding-bottom: 10px;
    border-bottom: 10px solid #f5f5f5;
    /deep/.van-tab--active {
      font-weight: bold;
    }
    /deep/ .van-hairline--top-bottom::after,
    .van-hairline-unset--top-bottom::after {
      border: none;
    }
  }
  .hasData {
    .topicItem {
      padding: 15px 0;
      margin: 0 20px;
      color: #999999;
      font-size: 12px;
      line-height: 16px;
      border-bottom: 1px solid #eeeeee;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .ti_left {
        width: 225px;
        .tilTitle {
          color: #333333;
          font-size: 18px;
          line-height: 20px;
          margin-bottom: 7px;
        }
        .times {
          margin-top: 13px;
          color: #666666;
          font-size: 10px;
          line-height: 13px;
          display: flex;
          .ellipsisView {
            position: relative;
            .icon-ellipsis {
              font-size: 12px;
              padding: 0 10px 0 0 !important;
            }
            .elv_black {
              width: 90px;
              background: #333333;
              color: #fff;
              font-size: 12px;
              border-radius: 6px;
              text-align: center;
              position: absolute;
              z-index: 2;
              top: 100%;
              left: 50%;
              transform: translate(-50%, 1%);
              -webkit-border-radius: 6px;
              -moz-border-radius: 6px;
              -ms-border-radius: 6px;
              -o-border-radius: 6px;
              div {
                height: 34px;
                line-height: 34px;
                border-top: 1px solid #666666;
                &:first-child {
                  border-top: none;
                }
              }
            }
          }
        }
        .times_mine {
          font-size: 11px;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
        .tiImg {
          width: 100px;
          height: 63px;
          position: relative;
          /deep/ .van-image {
            display: block;
            width: 100px;
            height: 63px;
          }
          .redDot {
            min-width: 24px;
            height: 24px;
            background: #d62f2f;
            border: 2px solid #ffffff;
            border-radius: 12px;
            position: absolute;
            z-index: 2;
            top: -8px;
            right: -9px;
            color: #fff;
            padding: 0 3px;
            box-sizing: border-box;
            text-align: center;
            line-height: 20px;
            font-size: 12px;
            -webkit-border-radius: 12px;
            -moz-border-radius: 12px;
            -ms-border-radius: 12px;
            -o-border-radius: 12px;
          }
        }
      }
    }
  }
  .createBtn {
    width: 100px;
    height: 35px;
    text-align: center;
    line-height: 35px;
    border: 1px solid #d62f2f;
    border-radius: 17px;
    font-size: 12px;
    color: #d62f2f;
    margin: 23px auto 0;
    -webkit-border-radius: 17px;
    -moz-border-radius: 17px;
    -ms-border-radius: 17px;
    -o-border-radius: 17px;
  }
}
</style>
